/**
 * Returns a formatted date string by adding the specified number of days to a given date string.
 * @param {number} offsetInDays - The number of days to add to the date.
 * @param {string} dateStr - The date string in ISO format ("YYYY-MM-DD").
 * @returns {string} - A formatted date string in the format "DD MMM".
 */

const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

const getCropActionDate = (offsetInDays: number, dateStr: string) => {
  const date = new Date(dateStr)
  date.setDate(date.getDate() + offsetInDays)
  const day = date.getDate()
  const monthIndex = date.getMonth()
  const month = months[monthIndex]
  return `${day} ${month}`
}

export default getCropActionDate
